import React, { useEffect, useRef } from 'react';
import { material } from '../../library/material'
import { useNavigate } from 'react-router-dom';
import { triggerRejectCall } from '../../services/VideoCallingService';


const Alert = React.forwardRef(function Alert(props, ref) {
    return <material.MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function CallNotification(props) {

    const { openCallNotification, setOpenCallNotification, stopRington } = props;
    const navigate = useNavigate();
    const audioRef = useRef(null);

    useEffect(() => {
        if (openCallNotification.action) {
            audioRef.current = new Audio(openCallNotification.data.ringtone);
            playRingtone();
        }
    }, [openCallNotification.action]);

    const playRingtone = () => {
        if (audioRef.current) {
            audioRef.current.loop = true;
            audioRef.current.muted = false;
            audioRef.current.play().catch(error => console.log("Autoplay blocked:", error));
        }
    };

    const addCall = (planRequestId) => {
        // navigate("/treatment-queue", { state: { planRequestId } });
        const treatmentPlanDetails = {
            treatmentPlanRequestId: planRequestId,
            incomingCall: true
        }
        // stopRington()
        navigate("/waiting-list/treatment-plan-details", { state: { treatmentPlanDetails } });
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            audioRef.current.muted = true;
            audioRef.current = null;
        }
        setOpenCallNotification({ action: false, data: null })
    };

    const rejectCall = async () => {
        // stopRington();
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            audioRef.current.muted = true;
            audioRef.current = null;
        }
        await triggerRejectCall(openCallNotification.data.data);
        setOpenCallNotification({ action: false, data: null });
    };

    return (
        <div>
            <material.Stack>
                <material.Snackbar open={openCallNotification.action} autoHideDuration={20000} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                    <Alert severity="info" sx={{ width: '100%' }}>
                        Incoming call for this Treatment plan requestId {openCallNotification.data?.data}
                        <span className='d-block mt-5 float-end'>
                            <material.Button sx={{ textTransform: "none", mr: 1 }} variant="contained" color='error' size="small" onClick={() => rejectCall(openCallNotification.data)}>Reject</material.Button>
                            <material.Button sx={{ textTransform: "none" }} variant="contained" color='success' size="small" onClick={() => addCall(openCallNotification.data.data)}>Answer</material.Button>
                        </span>
                    </Alert>
                </material.Snackbar>
            </material.Stack>
        </div>
    );
}

export default CallNotification;